module.exports = __webpack_public_path__ + "static/media/emailIcon.fbb0a84a.svg";